import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';

const WorkspaceListPage = withLazyLoading(
  () => import('../../pages/workspace-management/component/WorkspaceListPage')
);
const WorkspaceCreatePage = withLazyLoading(
  () => import('../../pages/workspace-management/component/WorkspaceCreatePage')
);
const WorkspaceConfig = withLazyLoading(() => import('../../pages/WorkspaceConfig'));
const WorkspaceConfigList = withLazyLoading(() => import('../../pages/WorkspaceConfigList'));

const workspaceRoutes = [
  {
    path: '/workspaceList',
    handle: createCrumbHandle('Workspaces'),
    children: [
        {
            index: true,
            element: <WorkspaceListPage />,
            // authz-v2 TODO: Workspace_View_R — gate server-side / useCan at component level
        },
        {
            path: 'createWorkspace/:id',
            element: <WorkspaceCreatePage />,
            // authz-v2 TODO: Workspace_Manage_A — gate server-side / useCan at component level
            handle: createCrumbHandle('Create Workspace'),
          },
          {
            path: 'editWorkspace/:id',
            element: <WorkspaceCreatePage />,
            // authz-v2 TODO: Workspace_Configuration_WE — gate server-side / useCan at component level
            handle: createCrumbHandle('Edit Workspace'),
          },
    ]
  },
  {
    path: '/WorkspaceConfig/:workspaceId',
    element: <WorkspaceConfig />,
    // authz-v2 TODO: Workspace_Configuration_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Workspace Configuration'),
  },
  {
    path: '/WorkspaceConfigList',
    element: <WorkspaceConfigList />,
    // authz-v2 TODO: Workspace_View_R — gate server-side / useCan at component level
    handle: createCrumbHandle('Workspaces'),
  },
];

export default workspaceRoutes;
